import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  // ErrorBoundary component to catch JavaScript errors in child components
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  // Lifecycle method to update state when an error is caught
  static getDerivedStateFromError(error) {
    return { hasError: true };
  }
  // Display fallback UI when an error is caught 
  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    // If an error has been caught, display the fallback UI
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-content">
            <div className="error-icon">⚠️</div>
            <h1>Oops! Something went wrong</h1>
            <p className="error-message">
              We're sorry for the inconvenience. The application encountered an unexpected error.
            </p>
            <div className="error-actions">
              <button 
                className="btn-primary"
                onClick={() => window.location.href = '/'}
              >
                Go to Home
              </button>
              <button 
                className="btn-secondary"
                onClick={() => window.location.reload()}
              >
                Reload Page
              </button>
            </div>
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <details className="error-details">
                <summary>Error Details (Development Only)</summary>
                <pre>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
